const HOME_SECTION_ALIASES = {
  "customized-offer": "services-tabs",
  plans: "services-tabs",
};

let lastMobileHeaderHeight = 0;

export const resolveHomeSectionId = (sectionId) =>
  HOME_SECTION_ALIASES[sectionId] || sectionId;

export const findHomeSectionElement = (sectionId) => {
  const resolvedId = resolveHomeSectionId(sectionId);
  return (
    document.getElementById(resolvedId) ||
    document.querySelector(`[data-section="${resolvedId}"]`)
  );
};

export const getHeaderScrollOffset = (extraGap = 16) => {
  const header =
    document.querySelector(".header.fixed") || document.querySelector(".header");
  if (!header) {
    return extraGap;
  }

  const rect = header.getBoundingClientRect();
  return Math.max(0, rect.bottom) + extraGap;
};

export const getVideoSectionScrollTarget = () => {
  const section = findHomeSectionElement("video");
  if (!section) return null;

  const headingCandidates = section.querySelectorAll(
    ".video-section .neural-heading, .video-section .heading-mobile__title"
  );

  const visibleHeading = [...headingCandidates].find(
    (element) => element.getClientRects().length > 0
  );

  return visibleHeading || section;
};

export const scrollToVideoSection = (options = {}) => {
  const target = getVideoSectionScrollTarget();
  if (!target) return;

  scrollToSection(target, {
    extraGap: 24,
    overlayDuration: 150,
    ...options,
  });
};

export const rememberMobileHeaderHeight = (header) => {
  if (window.innerWidth > 768) return;

  const height = header?.offsetHeight || 0;
  if (height > 0) {
    lastMobileHeaderHeight = height;
  }
};

export const getCaseShowcaseScrollOffset = () => {
  if (window.innerWidth > 768) return 0;

  const header =
    document.querySelector(".header.fixed") || document.querySelector(".header");
  const currentHeight = header?.offsetHeight || 0;
  return currentHeight || lastMobileHeaderHeight;
};

export const scrollToCaseShowcaseSection = (options = {}) => {
  const initialOffset = getCaseShowcaseScrollOffset();

  scrollToSection("case-showcase", {
    offset: initialOffset,
    overlayDuration: 150,
    ...options,
  });

  if (window.innerWidth <= 768 && typeof options.offset !== "number") {
    window.setTimeout(() => {
      const fixedHeaderOffset = getCaseShowcaseScrollOffset();
      if (Math.abs(fixedHeaderOffset - initialOffset) <= 1) return;

      scrollToSection("case-showcase", {
        offset: fixedHeaderOffset,
        overlayDuration: 0,
      });
    }, 500);
  }
};

export const scrollToServicesTabsSection = (options = {}) => {
  const initialOffset = getHeaderScrollOffset(0);

  scrollToSection("services-tabs", {
    offset: initialOffset,
    overlayDuration: 150,
    ...options,
  });

  if (typeof options.offset !== "number") {
    window.setTimeout(() => {
      scrollToSection("services-tabs", {
        offset: getHeaderScrollOffset(0),
        overlayDuration: 0,
      });
    }, 500);
  }
};

export const scrollToSection = (refOrId, options = {}) => {
  const smoothScrollTo = (element) => {
    if (!element) return;
    const overlayDuration = typeof options.overlayDuration === 'number' ? options.overlayDuration : 900;
    try { window.dispatchEvent(new CustomEvent('overlay:show', { detail: { duration: overlayDuration } })); } catch(_) {}
    try {
      window.dispatchEvent(
        new CustomEvent("header:suppressReveal", { detail: { duration: 1200 } })
      );
    } catch (_) {}
    const rect = element.getBoundingClientRect();
    const pageTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    const extraGap = typeof options.extraGap === "number" ? options.extraGap : 16;
    const offset =
      typeof options.offset === "number" ? options.offset : getHeaderScrollOffset(extraGap);
    const top = Math.max(0, rect.top + pageTop - offset);
    window.scrollTo({ top, behavior: 'smooth' });
  };

  if (typeof refOrId === 'string') {
    smoothScrollTo(findHomeSectionElement(refOrId));
  } else if (refOrId instanceof Element) {
    smoothScrollTo(refOrId);
  } else if (refOrId?.current) {
    smoothScrollTo(refOrId.current);
  }
};
